// extracted by mini-css-extract-plugin
export default {"h1-historia-empresa":"HistoriaEmpresa_h1-historia-empresa__qgT5Y","texto-historia-empresa":"HistoriaEmpresa_texto-historia-empresa__XM9Ej"};